import "./App.css";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";

import Cotizador from "./components/Cotizador";
import Peritajes from "./components/peritajes/Peritajes";

import Row from "react-bootstrap/Row";
//import Col from "react-bootstrap/Col";

function App() {
  let url_string = window.location.href;
  let url = new URL(url_string);
  const hash = url.searchParams.get("hash");

  return (
    <Router basename={"/cotizador"}>
      <Route exact path="/peritajes">
        <Peritajes hash={hash} />
      </Route>

      <Route exact path="/">
        <Row className="m-0 p-0">
          {/* <Col>Home del store</Col> */}
          {hash ? <Redirect to="/peritajes" /> : <Cotizador />}
        </Row>
      </Route>
    </Router>
  );
}

export default App;
